export default {
      id: "lamp-usage",
      viewBox: "0 0 21 41",
      url: __webpack_public_path__ + "img/icons.svg#lamp",
      toString: function () {
        return this.url;
      }
    }